<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion" [matTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)"
  [appOverflowTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>
  <!-- FILTROS -->  
  <!-- Filtro de Períodos -->
  <app-filters filtros [name]="'filtros.per' | translate" [array]="Periodos" [typeFilter]="Filters.PERIOD" 
    [click]="true" (eventClick)="cambioPeriodo($event)">
  </app-filters>
  <!-- Filtro de Escenarios -->
  <app-filters filtros [name]="'proyFinanciera.escenarioProyeccion.escenario' | translate"
    [array]="escenariosShow" [typeFilter]="Filters.ESCENARIOS" [click]="false"
    (eventClick)="escenarioChange($event)">
  </app-filters>
  <!-- Filtro de Sucursales -->
  @if(sucursales.length > 1){
    <app-filters filtros [name]="'filtros.sucursales'+tagInstitucion | translate" [array]="sucursales"
      [typeFilter]="Filters.ESCENARIOS" [click]="false"
      (eventClick)="sucursalChange($event)">
    </app-filters>
  }
  <!-- Análisis -->
  @if(!estructura){
    <app-filters filtros [name]="'filtros.ana' | translate" [array]="perspectives" [typeFilter]="Filters.PERSPECTIVES" 
      [click]="false" (eventClick)="onAnalisisHorizontalChange($event)"/>
  }  
  <div borrador>
    <div class="w3-button w3-dropdown-click" style="transform: scale(0.9);" [ngStyle]="{'color':'gray'}"
      matTooltip="{{'tooltips.borrar-filtros'|translate}}" (click)="resetFilters()">
      <img src="./../../../../assets/img/eraser.png">
    </div>
  </div>
  <!-- CONTENIDO -->
  <div contenido class="zonaContenido">
    <div class="w3-row w3-header-cuadrante">
      <div class="w3-half hijoIzquierdaTitle w3-titulo-contenidomenu">
        <div class="hijoizquierdaTitle">
          <span class="w3-margin-left-contenido">{{ metricaSeleccionada }} | 
            @if(!balanceEstados && encMet == 2){ {{'segPresupuestal.estadoFinanciero.titMovimientos' | translate}} | }
            @if(!consolidado) {{{'segPresupuestal.estadoFinanciero.sucursal'+tagInstitucion | translate}}} {{ sucursalSeleccionada?.name }}</span>
          <span class="w3-punto-subtitulo w3-margin-left-filter">&bull;</span>
          <span class=" w3-margin-left-filter w3-subtitulo">{{ periodoSeleccionado?.nombre}} | {{ escenarioSeleccionado?.name }}</span>
        </div>
      </div>
      <div class="w3-rest w3-right-align_rest">
        <mat-icon class="w3-button w3-margin-right-contenido" [ngStyle]="{'color':'gray', 'cursor': 'pointer'}"
          [matMenuTriggerFor]="opcionesTabla" matTooltip="Más opciones">
          more_vert
        </mat-icon>
        <!-- Menú Más opciones con Exportar y Métrica -->
        <mat-menu #opcionesTabla="matMenu">
          <button class="mat-menu-item w3-caja-menu" mat-menu-item 
            (click)="cambiarMetrica(balanceEstados 
              ? 'segPresupuestal.estadoFinanciero.edoResul' 
              : 'segPresupuestal.estadoFinanciero.balance')">
            <span>
              {{(balanceEstados 
              ? 'segPresupuestal.estadoFinanciero.edoResul' 
              : 'segPresupuestal.estadoFinanciero.balance') | translate}}
            </span>
          </button>
          @if(balanceEstados && !estructura){
            <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="this.estructura = ! this.estructura;">
              <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">insert_chart</mat-icon>
              <span>{{'segPresupuestal.estadoFinanciero.grafEstructura'|translate}}</span>
            </button>                          
          }
          @if(balanceEstados && estructura){
            <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="estructura = false">
              <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">table</mat-icon>
              <span>{{'segPresupuestal.estadoFinanciero.verBalance'|translate}}</span>
            </button>    
          }
          @if(!balanceEstados){
            <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="menuMetrica">
              <mat-icon [ngStyle]="{'color':'gray'}">tag</mat-icon>
              <span>{{'menu.Metrica' | translate}}</span>
            </button>  
          }   
          @if(!estructura){
            <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportarTabla()">
              <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">description</mat-icon>
              <span>{{'menu.Exportar'|translate}}</span>
            </button>   
          }               
                           
        </mat-menu>
        <mat-menu #menuMetrica="matMenu">
          <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled':encMet === 1}" [disabled]="encMet === 1"  (click)="cambioConsolidadoSaldo(1)">
            <span>{{'segPresupuestal.estadoFinanciero.metrica1'|translate}}</span>
          </button>
          <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled':encMet === 2}" [disabled]="encMet === 2" (click)="cambioConsolidadoSaldo(2)">
            <span>{{'segPresupuestal.estadoFinanciero.metrica2'|translate}}</span>
          </button>
        </mat-menu>
      </div>
    </div>
    @if(!estructura){
      <div class="containerAll w3-white w3-scroll">
        <div >
          @if (cuentasVisibles.length === 0) {<app-skeleton-table [columnas]="6" [filas]="14"/>}
          @else {
            <table class="w3-table">
              <thead>
                @if(encMet == 2){
                  <tr class="w3-center">
                    @if(perspectives[0].check){
                      <th colspan="2" class="stikyColumBlanco"></th>
                      <th colspan="6" class="w3-table-titleLow stikyColumCon w3-border-right-balance">{{'segPresupuestal.estadoFinanciero.tituloTabla3' | translate}}</th>
                      <th colspan="6" class="w3-table-titleLow stikyColumCon textColor">{{'segPresupuestal.estadoFinanciero.tituloTabla2' | translate}}</th>
                    }@else {
                      <th colspan="2" class="stikyColumBlanco"></th>
                      <th colspan="4" class="w3-table-titleLow stikyColumCon w3-border-right-balance">{{'segPresupuestal.estadoFinanciero.tituloTabla3' | translate}}</th>
                      <th colspan="4" class="w3-table-titleLow stikyColumCon">{{'segPresupuestal.estadoFinanciero.tituloTabla2' | translate}}</th>
                    }
                  </tr>
                }
                <tr class="w3-table-title w3-center" style="line-height: 1.2;">
                  <th class="w3-border-right-balance marginsH" style="width: 110px;"
                  [ngClass]="encMet == 2 ? 'stikyColumCon2' : 'stikyColumCon'" >
                    {{'segPresupuestal.estadoFinanciero.titTab1' | translate}}
                  </th>
                  <th class="w3-border-right-balance" style="min-width: 200px;"
                  [ngClass]="encMet == 2 ? 'stikyColumCon2' : 'stikyColumCon'">
                    <div class="tituloIcono">
                      <mat-icon class="iconoMen iconoIzq" (click)="contraerExpandirTodo()"
                        [matTooltip]="(!contraerExpandir
                          ? 'segPresupuestal.estadoFinanciero.expandirT'
                          : 'segPresupuestal.estadoFinanciero.contraerT') | translate">
                        {{ contraerExpandir ? 'expand_more' : 'chevron_right' }}
                      </mat-icon>
                      <span>{{ 'segPresupuestal.estadoFinanciero.titTab2' | translate }}</span>
                    </div>
                  </th>
                  @if(encMet === 2){
                    <th class="w3-border-right-balance marginsH" style="min-width: 150px;"
                    [ngClass]="encMet == 2 ? 'stikyColumCon2' : 'stikyColumCon'">
                      {{'segPresupuestal.estadoFinanciero.titTab3' | translate}}
                    </th>
                    @if (perspectives[0].check) {
                      <th class="w3-border-right-balance marginsH textColorN1" style="min-width: 100px;"
                      [ngClass]="encMet == 2 ? 'stikyColumCon2' : 'stikyColumCon'">%</th>
                    }
                    <th class="w3-border-right-balance" style="min-width: 150px;"
                    [ngClass]="encMet == 2 ? 'stikyColumCon2' : 'stikyColumCon'">
                      <div class="tituloIcono">
                        <span>{{'segPresupuestal.estadoFinanciero.titTab4' | translate}}</span>
                        <mat-icon class="iconoMen iconoDer" (click)="onSinSaldoChange()" matTooltip="Sin saldo">
                          {{ !sinSaldo ? 'filter_alt' : 'filter_alt_off' }}</mat-icon>
                      </div>
                    </th>
                    @if (perspectives[0].check) {
                      <th class="w3-border-right-balance marginsH textColorN1" style="min-width: 100px;"
                      [ngClass]="encMet == 2 ? 'stikyColumCon2' : 'stikyColumCon'">%</th>
                    }
                    <th class="w3-border-right-balance marginsH" style="min-width: 150px;"
                    [ngClass]="encMet == 2 ? 'stikyColumCon2' : 'stikyColumCon'">
                      {{'segPresupuestal.estadoFinanciero.titTab5' | translate}}
                    </th>
                    <th class="w3-border-right-balance" style="min-width: 150px;"
                    [ngClass]="encMet == 2 ? 'stikyColumCon2' : 'stikyColumCon'">
                      <div class="tituloIcono">
                        <span>{{'segPresupuestal.estadoFinanciero.titTab6' | translate}}</span>
                        <mat-icon class="iconoMen iconoDer" (click)="semaforo = !semaforo" matTooltip="Semáforo">
                          {{ !semaforo ? 'traffic' : 'traffic' }}</mat-icon>
                      </div>
                    </th>
                  }
                  <th class="w3-border-right-balance marginsH" style="min-width: 150px;"
                  [ngClass]="encMet == 2 ? 'stikyColumCon2' : 'stikyColumCon'">
                    {{'segPresupuestal.estadoFinanciero.titTab3' | translate}}
                  </th>
                  @if (perspectives[0].check) {
                    <th class="w3-border-right-balance marginsH textColorN1" style="min-width: 100px;"
                    [ngClass]="encMet == 2 ? 'stikyColumCon2' : 'stikyColumCon'">%</th>
                  }
                  <th class="w3-border-right-balance" style="min-width: 150px;"
                  [ngClass]="encMet == 2 ? 'stikyColumCon2' : 'stikyColumCon'">
                    <div class="tituloIcono">
                      <span>{{'segPresupuestal.estadoFinanciero.titTab4' | translate}}</span>
                      <mat-icon class="iconoMen iconoDer" (click)="onSinSaldoChange()" matTooltip="Sin saldo">
                        {{ !sinSaldo ? 'filter_alt' : 'filter_alt_off' }}</mat-icon>
                    </div>
                  </th>
                  @if (perspectives[0].check) {
                    <th class="w3-border-right-balance marginsH textColorN1" style="min-width: 100px;"
                    [ngClass]="encMet == 2 ? 'stikyColumCon2' : 'stikyColumCon'">%</th>
                  }
                  <th class="w3-border-right-balance marginsH" style="min-width: 150px;"
                  [ngClass]="encMet == 2 ? 'stikyColumCon2' : 'stikyColumCon'">
                    {{'segPresupuestal.estadoFinanciero.titTab5' | translate}}
                  </th>
                  <th class="w3-border-right-balance" style="min-width: 150px;"
                  [ngClass]="encMet == 2 ? 'stikyColumCon2' : 'stikyColumCon'">
                    <div class="tituloIcono">
                      <span>{{'segPresupuestal.estadoFinanciero.titTab6' | translate}}</span>
                      <mat-icon class="iconoMen iconoDer" (click)="semaforo = !semaforo" matTooltip="Semáforo">
                        {{ !semaforo ? 'traffic' : 'traffic' }}</mat-icon>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (cuenta of cuentasVisibles; track cuenta.id; let i = $index) {
                  <tr class="w3-table-trtd" [style.cursor]="cuenta.hijos.length > 0 ? 'pointer' : 'default'" style="line-height: 1.2;"
                    [ngClass]="{'selection' : cuentaSelec.id === cuenta.id}" (click)="cuentaSeleccionada(cuenta)">
                    <td class="borderLowDSI marginsH alinRight">{{ cuenta.codigo }}</td>
                    <td class="borderAllLow alinLeft" [style.padding-left]="getIndentacion(cuenta)">
                      @if (cuenta.hijos.length > 0) {
                        <mat-icon class="material-icons-outlined" (click)="toggleExpansion(cuenta)" style="vertical-align: middle; font-size: 18px;"
                          [matTooltip]="(!cuenta.expandido 
                            ? 'segPresupuestal.estadoFinanciero.expandir' 
                            : 'segPresupuestal.estadoFinanciero.contraer') | translate">
                            {{ !cuenta.expandido ? 'expand_more' : 'chevron_right' }}
                        </mat-icon>
                      }
                      <span [style.font-weight]="cuenta.nivel === 1 ? 'bold' : 'normal'"
                      [style.margin-left]="cuenta.hijos == 0 ? '7px' : '0px'">{{ cuenta.nombre }}</span>
                    </td>
                    @if(encMet === 2){
                      <td class="borderAllLow marginsH alinRight">
                        {{ cuenta.presupuestoMov !== '-' ? (cuenta.presupuestoMov | formaterNumber:2:miles:decimal) : '-' }}</td>
                      @if (perspectives[0].check) {
                        <td class="borderAllLow marginsH  w3-center" style="font-size: 0.85em; color: #666;"
                          [ngClass]="{'textColorN1':cuenta.nivel===1,
                                    'textColorN2':cuenta.nivel===2,
                                    'textColorN3':cuenta.nivel===3,
                                    'textColorN4':cuenta.nivel>=4}">
                          {{cuenta.presupuestoMov !== '-' ? 
                          (cuenta.analisisVerticalPresupuestoMov | formaterNumber:2:miles:decimal) : '-'}} %
                        </td>
                      }
                      <td class="borderAllLow marginsH alinRight">{{ cuenta.realMov !== '-' ? (cuenta.realMov | formaterNumber:2:miles:decimal) : '-' }}</td>
                      @if (perspectives[0].check) {
                        <td class="borderAllLow marginsH w3-center" style="font-size: 0.85em; color: #666;"
                          [ngClass]="{'textColorN1':cuenta.nivel===1,
                                    'textColorN2':cuenta.nivel===2,
                                    'textColorN3':cuenta.nivel===3,
                                    'textColorN4':cuenta.nivel>=4}">
                          {{cuenta.real !== '-' ? (cuenta.analisisVerticalRealMov | formaterNumber:2:miles:decimal) : '-' }} %
                        </td>
                      }
                      <td class="borderAllLow marginsH alinRight">
                        <span [style.color]="semaforo ? obtenerColorSemaforo(cuenta.cumplimientoMov) : '#666'">
                          {{cuenta.variacion !== '-' ? (cuenta.variacion | formaterNumber:2:miles:decimal) : '-'}}
                        </span>
                      </td>
                      <td class="borderAllLow marginsH w3-center">
                        <span [style.color]="semaforo ? obtenerColorSemaforo(cuenta.cumplimientoMov) : '#666'">
                          {{cuenta.cumplimientoMov !== '-' ? (cuenta.cumplimientoMov | formaterNumber:2:miles:decimal) : '-'}} %
                        </span>
                      </td>  
                    }
                    <td class="borderAllLow marginsH alinRight">{{ cuenta.presupuesto !== '-' ? (cuenta.presupuesto | formaterNumber:2:miles:decimal) : '-' }}</td>
                    @if (perspectives[0].check) {
                      <td class="borderAllLow marginsH w3-center" style="font-size: 0.85em; color: #666;"
                        [ngClass]="{'textColorN1':cuenta.nivel===1,
                                    'textColorN2':cuenta.nivel===2,
                                    'textColorN3':cuenta.nivel===3,
                                    'textColorN4':cuenta.nivel>=4}">
                        {{cuenta.presupuesto !== '-' ? (cuenta.analisisVerticalPresupuesto | formaterNumber:2:miles:decimal) : '-' }} %
                      </td>
                    }
                    <td class="borderAllLow marginsH alinRight">{{ cuenta.real !== '-' ? (cuenta.real | formaterNumber:2:miles:decimal) : '-' }}</td>
                    @if (perspectives[0].check) {
                      <td class="borderAllLow marginsH w3-center" style="font-size: 0.85em; color: #666;"
                        [ngClass]="{'textColorN1':cuenta.nivel===1,
                                    'textColorN2':cuenta.nivel===2,
                                    'textColorN3':cuenta.nivel===3,
                                    'textColorN4':cuenta.nivel>=4}">
                        {{cuenta.real !== '-' ? (cuenta.analisisVerticalReal | formaterNumber:2:miles:decimal) : '-'}} %
                      </td>
                    }
                    <td class="borderAllLow marginsH alinRight">
                      <span [style.color]="semaforo ? obtenerColorSemaforo(cuenta.cumplimiento) : '#666'">
                        {{cuenta.variacion !== '-' ? (cuenta.variacion | formaterNumber:2:miles:decimal) : '-' }}
                      </span>
                    </td>
                    <td class="borderLowISI marginsH w3-center">
                      <span [style.color]="semaforo ? obtenerColorSemaforo(cuenta.cumplimiento) : '#666'">
                        {{ cuenta.cumplimiento !== '-' ? (cuenta.cumplimiento | formaterNumber:2:miles:decimal) : '-'}} %
                      </span>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          }
        </div>
        <!-- Zona Inferior - Gráfico Combinado -->
        <div class="zonaGraf w3-white">
          <div class="headers w3-titulo-contenidomenuSC" w3-header-cuadrante>
            <div class="w3-half hijoIzquierdaTitle w3-titulo-contenidomenu">
              <span class="w3-margin-left-contenido">{{ metricaSeleccionada }} | 
                @if(!balanceEstados && encMet == 2){ {{'segPresupuestal.estadoFinanciero.titMovimientos' | translate}} | }
                {{titGrafica}} {{cuentaSelec?.nombre}}   </span>
              <span class="w3-punto-subtitulo w3-margin-left-filter">&bull;</span>
              <span class=" w3-margin-left-filter w3-subtitulo">{{ periodoSeleccionado?.nombre }} | {{ escenarioSeleccionado?.name }} | {{ sucursalSeleccionada?.name }}</span>
            </div>
            <div class="w3-rest w3-right">
              @if(etiquetas){
                <mat-icon class="iconoMen w3-button w3-dropdown-click" style="margin-right: 5px;" [ngStyle]="{'color':'gray'}" 
                  (click)="changeLabel = !changeLabel"  matTooltip="{{'graf.etiquetas'|translate}}">new_label</mat-icon>
              }
              <!-- Icono de etiquetas -->
              <mat-icon class="w3-button iconoMen material-icons-outlined" [ngStyle]="{'color':'gray'}" 
                (click)="onOffLabels()" [matTooltip]="etiquetas ? ('graf.desactivar'|translate) : ('graf.activar' | translate)">
                {{ etiquetas ? 'label_off' : 'label'}}
              </mat-icon>
              <!-- Icono de expandir -->
              <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
                (click)="ampliarGraf(1)" matTooltip="{{'tooltips.tooltipIcono2'|translate}}">
                zoom_out_map
              </mat-icon>
              <!-- Menú de opciones -->
              <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                [matMenuTriggerFor]="menuGrafica" matTooltip="Opciones">
                more_vert
              </mat-icon>
              <mat-menu #menuGrafica="matMenu"> 
                <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="tipoGrafica">
                  <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">insert_chart</mat-icon>
                  <span>{{'graf.graficas'|translate}}</span>
                </button>
                <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportarGrafica(1)">
                  <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">image</mat-icon>
                  <span>{{'menu.Exportar'|translate}}</span>
                </button>
              </mat-menu>
              <!-- Submenu de tipos de gráfica -->
              <mat-menu #tipoGrafica="matMenu">
                <button class="mat-menu-item w3-caja-menu" mat-menu-item 
                  [ngClass]="{'w3-disabled': tipoGraficaActual === typeGrap.COMBO}"
                  [disabled]="tipoGraficaActual === typeGrap.COMBO"
                  (click)="cambiarTipoGrafica(typeGrap.COMBO)">
                  <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                  <span>{{'credito.concentracion.tipografica'|translate}}</span>
                </button>
                <button class="mat-menu-item w3-caja-menu" mat-menu-item 
                  [ngClass]="{'w3-disabled': tipoGraficaActual === typeGrap.BAR}"
                  [disabled]="tipoGraficaActual === typeGrap.BAR"
                  (click)="cambiarTipoGrafica(typeGrap.BAR)">
                  <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                  <span>{{'graf.barras'|translate}}</span>
                </button>
                <button class="mat-menu-item w3-caja-menu" mat-menu-item 
                  [ngClass]="{'w3-disabled': tipoGraficaActual === typeGrap.LINE}"
                  [disabled]="tipoGraficaActual === typeGrap.LINE"
                  (click)="cambiarTipoGrafica(typeGrap.LINE)">
                  <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
                  <span>{{'graf.lineal'|translate}}</span>
                </button>
                <button class="mat-menu-item w3-caja-menu" mat-menu-item 
                  [ngClass]="{'w3-disabled': tipoGraficaActual === typeGrap.AREA}"
                  [disabled]="tipoGraficaActual === typeGrap.AREA"
                  (click)="cambiarTipoGrafica(typeGrap.AREA)">
                  <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">area_chart</mat-icon>
                  <span>{{'graf.area'|translate}}</span>
                </button>                  
              </mat-menu>
            </div>
          </div>
          <div style="height: 90%;">
            @if (datoGrafico.length > 0) {
              <app-graficador
                [data]="datoGrafico"
                [labels]="etiquetasGrafico"
                [type]="tipoGraficaActual"
                [colors]="coloresGrafico"
                [axisY]="['% Cumplimiento', 'Millones']"
                [axisX]=""
                [zona]="1"
                [legend]="{enabled: true, position: 'bottom'}"
                [etiquetas]="etiquetas"
                [changeLabel]="changeLabel"
                [formatEtiquetas]="true"
                [setTwoLast]="ejes"
                [animations]="true"
                [alinearYIzquierda]="true"
                [stroke]="false">
              </app-graficador>
            }@else {<app-skeleton-grafica />}
          </div>         
        </div>  
      </div>
    }@else{
      <div class="w3-row">
        <div class="w3-third tarjeta">
          <mat-card class="tarjeta-zone">
            @if(tarjetasEstructura[0]; as tarjeta){
              <div class="tarjetaTitulo">{{ tarjeta.nombre }}</div>
              <div class="tarjeta-zone_contenido">
                <div class="tarjeta-zone_metrica tarjeta-zone_metrica-separada">
                  <span class="tarjeta-zone_etiqueta">
                    {{ 'segPresupuestal.estadoFinanciero.titTab4' | translate }}
                  </span>
                  <strong class="tarjeta-zone_valor">
                    {{ tarjeta.real / 1000000  | formaterNumber:2:miles:decimal}} M
                  </strong>
                </div>
                <div class="tarjeta-zone_metrica">
                  <span class="tarjeta-zone_etiqueta">
                    {{ 'segPresupuestal.estadoFinanciero.titTab3' | translate }}
                  </span>
                  <strong class="tarjeta-zone_valor">
                    {{ tarjeta.presupuesto / 1000000  | formaterNumber:2:miles:decimal }} M
                  </strong>
                </div>
                <div class="tarjeta-zone_metrica tarjeta-zone_variacion">
                  <span class="tarjeta-zone_etiqueta">
                    {{ 'segPresupuestal.estadoFinanciero.titTab5' | translate }}
                  </span>
                  <strong
                    class="tarjeta-zone_valor tarjeta-zone_valor-variacion"
                    [class.tarjeta-zone_valor-positivo]="tarjeta.variacion >= 0"
                    [class.tarjeta-zone_valor-negativo]="tarjeta.variacion < 0">
                    {{ tarjeta.cumplimiento - 100 | formaterNumber:2:miles:decimal }}%
                    <span>{{ tarjeta.variacion >= 0 ? '▲' : '▼' }}</span>
                  </strong>
                  <span class="tarjeta-zone_subvalor">
                    {{ tarjeta.variacion / 1000000  | formaterNumber:2:miles:decimal }} M
                  </span>
                </div>
              </div>  
            }@else{<app-skeleton-card/>}            
          </mat-card>
        </div>    
        <div class="w3-third tarjeta">
          <mat-card class="tarjeta-zone">
            @if(tarjetasEstructura[1]; as tarjeta){
              <div class="tarjetaTitulo">{{ tarjeta.nombre }}</div>
              <div class="tarjeta-zone_contenido">
                <div class="tarjeta-zone_metrica tarjeta-zone_metrica-separada">
                  <span class="tarjeta-zone_etiqueta">
                    {{ 'segPresupuestal.estadoFinanciero.titTab4' | translate }}
                  </span>
                  <strong class="tarjeta-zone_valor">
                    {{ tarjeta.real / 1000000  | formaterNumber:2:miles:decimal}} M
                  </strong>
                </div>

                <div class="tarjeta-zone_metrica">
                  <span class="tarjeta-zone_etiqueta">
                    {{ 'segPresupuestal.estadoFinanciero.titTab3' | translate }}
                  </span>
                  <strong class="tarjeta-zone_valor">
                    {{ tarjeta.presupuesto / 1000000  | formaterNumber:2:miles:decimal }} M
                  </strong>
                </div>

                <div class="tarjeta-zone_metrica tarjeta-zone_variacion">
                  <span class="tarjeta-zone_etiqueta">
                    {{ 'segPresupuestal.estadoFinanciero.titTab5' | translate }}
                  </span>
                  <strong
                    class="tarjeta-zone_valor tarjeta-zone_valor-variacion"
                    [class.tarjeta-zone_valor-positivo]="tarjeta.variacion >= 0"
                    [class.tarjeta-zone_valor-negativo]="tarjeta.variacion < 0">
                    {{ tarjeta.cumplimiento - 100 | formaterNumber:2:miles:decimal }}%
                    <span>{{ tarjeta.variacion >= 0 ? '▲' : '▼' }}</span>
                  </strong>
                  <span class="tarjeta-zone_subvalor">
                    {{ tarjeta.variacion / 1000000  | formaterNumber:2:miles:decimal }} M
                  </span>
                </div>
              </div>  
            }@else{<app-skeleton-card/>}            
          </mat-card>
        </div>    
        <div class="w3-third tarjeta">
          <mat-card class="tarjeta-zone">
            @if(tarjetasEstructura[2]; as tarjeta){
              <div class="tarjetaTitulo">{{ tarjeta.nombre }}</div>
              <div class="tarjeta-zone_contenido">
                <div class="tarjeta-zone_metrica tarjeta-zone_metrica-separada">
                  <span class="tarjeta-zone_etiqueta">
                    {{ 'segPresupuestal.estadoFinanciero.titTab4' | translate }}
                  </span>
                  <strong class="tarjeta-zone_valor">
                    {{ tarjeta.real / 1000000  | formaterNumber:2:miles:decimal}} M
                  </strong>
                </div>

                <div class="tarjeta-zone_metrica">
                  <span class="tarjeta-zone_etiqueta">
                    {{ 'segPresupuestal.estadoFinanciero.titTab3' | translate }}
                  </span>
                  <strong class="tarjeta-zone_valor">
                    {{ tarjeta.presupuesto / 1000000  | formaterNumber:2:miles:decimal }} M
                  </strong>
                </div>

                <div class="tarjeta-zone_metrica tarjeta-zone_variacion">
                  <span class="tarjeta-zone_etiqueta">
                    {{ 'segPresupuestal.estadoFinanciero.titTab5' | translate }}
                  </span>
                  <strong
                    class="tarjeta-zone_valor tarjeta-zone_valor-variacion"
                    [class.tarjeta-zone_valor-positivo]="tarjeta.variacion >= 0"
                    [class.tarjeta-zone_valor-negativo]="tarjeta.variacion < 0">
                    {{ tarjeta.cumplimiento - 100 | formaterNumber:2:miles:decimal }}%
                    <span>{{ tarjeta.variacion >= 0 ? '▲' : '▼' }}</span>
                  </strong>
                  <span class="tarjeta-zone_subvalor">
                    {{ tarjeta.variacion / 1000000  | formaterNumber:2:miles:decimal }} M
                  </span>
                </div>
              </div>  
            }@else{<app-skeleton-card/>}            
          </mat-card>
        </div>    
      </div>
      <div style="margin-left: 25px;"><span style="font-size: 10pt; color: #465168">{{'segPresupuestal.estadoFinanciero.cifras' | translate}}</span></div>
      <div class="w3-scroll w3-row" style="height: 60vh; margin-top: 1vh;">
        <div class="w3-row w3-white w3-half conteEstructura">
          <div class="w3-row w3-titulo-contenidomenuSC">
            <div class="headers w3-setenta textoOverFlow" style="width: 65%;"
              matTooltip="{{estructuraR1.titulo}} &bull; {{'segPresupuestal.estadoFinanciero.titTab4' | translate}} | {{periodoSeleccionado.nombre}}">
              <span class="w3-margin-left-contenido">{{estructuraR1.titulo}} | {{'segPresupuestal.estadoFinanciero.titTab4' | translate}}</span>
              <span class="w3-margin-left-contenido">&bull;</span>
              <span class="w3-margin-left-filter w3-subtitulo"> {{periodoSeleccionado?.nombre}}</span>
            </div>
            <div class="w3-rest w3-right">
              @if (estructuraR1.filtroActivado) {
                <div class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                (click)="borrarFiltroEstructura(1)" style="transform: scale(0.9);" matTooltip="{{'financiero.catalogoCuentas.tooltipIcono7'|translate}}">
                  <img src="assets/img/eraser.png">
                </div>
              }
              <mat-icon fontSet="material-icons-outlined" class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
              (click)="estructuraR1.showLabels = !estructuraR1.showLabels" matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
                {{ estructuraR1.showLabels ? 'label_off' : 'label' }}
              </mat-icon> 
              <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
              (click)="ampliarGraf(2)" matTooltip="{{'financiero.catalogoCuentas.tooltipIcono2'|translate}}">
                zoom_out_map
              </mat-icon>
              <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
              [matMenuTriggerFor]="menuGraf1">
                more_vert
              </mat-icon>
              <mat-menu #menuGraf1="matMenu">
                <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="graficas1">
                  <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                  <span>{{'financiero.catalogoCuentas.tooltipIcono3'|translate}}</span>
                </button>
                <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportarGrafica(2)">
                  <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                  <span>{{'menu.Exportar'|translate}}</span>
                </button>
              </mat-menu>
              <mat-menu #graficas1="matMenu">
                <button mat-menu-item  [ngClass]="{'w3-disabled': estructuraR1.tipo === typeGrap.BAR}" 
                [disabled]="estructuraR1.tipo === typeGrap.BAR"  (click)="cambiarGraficaEstructura('BAR', 1)">
                  <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                  <span>{{'graf.vertical'|translate}}</span>
                </button>
                <button mat-menu-item [ngClass]="{'w3-disabled': estructuraR1.tipo === typeGrap.LINE}" 
                [disabled]="estructuraR1.tipo === typeGrap.LINE" (click)="cambiarGraficaEstructura('LINE', 1)">
                  <mat-icon [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
                  <span>{{'graf.lineal'|translate}}</span>
                </button>
                <button mat-menu-item  [ngClass]="{'w3-disabled': estructuraR1.tipo === typeGrap.BARHORIZONTAL}" 
                [disabled]="estructuraR1.tipo === typeGrap.BARHORIZONTAL"  (click)="cambiarGraficaEstructura('BARHORIZONTAL', 1)">
                  <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                  <span>{{'graf.horizontal'|translate}}</span>
                </button>
                <button mat-menu-item  [ngClass]="{'w3-disabled': estructuraR1.tipo === typeGrap.HEATMAP}"
                [disabled]="estructuraR1.tipo === typeGrap.HEATMAP"  (click)="cambiarGraficaEstructura('HEATMAP', 1)">
                  <mat-icon [ngStyle]="{'color':'gray'}">view_quilt</mat-icon>
                  <span>{{'graf.calor'|translate}}</span>
                </button>
                <button mat-menu-item  [ngClass]="{'w3-disabled': estructuraR1.tipo === typeGrap.PIE}"
                [disabled]="estructuraR1.tipo === typeGrap.PIE"  (click)="cambiarGraficaEstructura('PIE', 1)">
                  <mat-icon [ngStyle]="{'color':'gray'}">pie_chart</mat-icon>
                  <span>{{'graf.pie'|translate}}</span>
                </button>
              </mat-menu>
            </div>
          </div>
          <div class="grafEstruc">
            @if (estructuraR1.data.length > 0) {
              <app-graficador
                [data]="estructuraR1.data"
                [labels]="estructuraR1.etiquetas"
                [type]="estructuraR1.tipo"
                [colors]="coloresGraf2"
                [axisY]="['']"
                [axisX]="''"
                [zona]="2"
                [legend]="estructuraR1.tipo === typeGrap.PIE ? {enabled: true, position: 'right'} : {enabled: false, position: 'bottom'}"
                [etiquetas]="estructuraR1.showLabels"
                [altoEtiquetasX] = "estructuraR1.tipo === typeGrap.BARHORIZONTAL ? 200 : 100"
                [animations]="false"
                [distributed]="estructuraR1.tipo !== typeGrap.PIE"
                [formatEtiquetas]="false"
                [divisionesEjeX]="4"
                [agruparCategoriasExcedentes]="true"
                [maxCategoriasVisibles]="5"
                [etiquetaOtros]="'segPresupuestal.estadoFinanciero.otros' | translate"
                [ordenCategorias]="'descendente'"
                [info]="'segPresupuestal.estadoFinanciero.info' | translate"
                (eventClick)="filtroEstruc1($event)">
              </app-graficador>
            }@else {<app-skeleton-grafica />}
          </div>
        </div>
        <div class="w3-row w3-white w3-half conteEstructura">
          <div class="w3-row w3-titulo-contenidomenuSC">
            <div class="headers w3-setenta textoOverFlow" style="width: 65%;"
            matTooltip="{{estructuraP1.titulo}} &bull; {{'segPresupuestal.estadoFinanciero.titTab3' | translate}} {{periodoSeleccionado.nombre}}">
              <span class="w3-margin-left-contenido">{{estructuraP1.titulo}} | {{'segPresupuestal.estadoFinanciero.titTab3' | translate}}</span>
              <span class="w3-margin-left-contenido">&bull;</span>
              <span class="w3-margin-left-filter w3-subtitulo"> {{periodoSeleccionado?.nombre}}</span>
            </div>
            <div class="w3-rest w3-right">
              @if (estructuraP1.filtroActivado) {
                <div class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                (click)="borrarFiltroEstructura(1)" style="transform: scale(0.9);" matTooltip="{{'financiero.catalogoCuentas.tooltipIcono7'|translate}}">
                  <img src="assets/img/eraser.png">
                </div>
              }
              <mat-icon fontSet="material-icons-outlined" class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
              (click)="estructuraP1.showLabels = !estructuraP1.showLabels" matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
                {{ estructuraP1.showLabels ? 'label_off' : 'label' }}
              </mat-icon> 
              <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
              (click)="ampliarGraf(3)" matTooltip="{{'financiero.catalogoCuentas.tooltipIcono2'|translate}}">
                zoom_out_map
              </mat-icon>
              <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
              [matMenuTriggerFor]="menuGraf2">
                more_vert
              </mat-icon>
              <mat-menu #menuGraf2="matMenu">
                <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="graficas2">
                  <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                  <span>{{'financiero.catalogoCuentas.tooltipIcono3'|translate}}</span>
                </button> 
                <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportarGrafica(3)">
                  <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                  <span>{{'menu.Exportar'|translate}}</span>
                </button>
              </mat-menu>
              <mat-menu #graficas2="matMenu">
                <button mat-menu-item  [ngClass]="{'w3-disabled': estructuraP1.tipo === typeGrap.BAR}" 
                [disabled]="estructuraP1.tipo === typeGrap.BAR"  (click)="cambiarGraficaEstructura('BAR', 2)">
                  <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                  <span>{{'graf.vertical'|translate}}</span>
                </button>
                <button mat-menu-item [ngClass]="{'w3-disabled': estructuraP1.tipo === typeGrap.LINE}" 
                [disabled]="estructuraP1.tipo === typeGrap.LINE" (click)="cambiarGraficaEstructura('LINE', 2)">
                  <mat-icon [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
                  <span>{{'graf.lineal'|translate}}</span>
                </button>
                <button mat-menu-item  [ngClass]="{'w3-disabled': estructuraP1.tipo === typeGrap.BARHORIZONTAL}" 
                [disabled]="estructuraP1.tipo === typeGrap.BARHORIZONTAL"  (click)="cambiarGraficaEstructura('BARHORIZONTAL', 2)">
                  <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                  <span>{{'graf.horizontal'|translate}}</span>
                </button>
                <button mat-menu-item  [ngClass]="{'w3-disabled': estructuraP1.tipo === typeGrap.HEATMAP}"
                [disabled]="estructuraP1.tipo === typeGrap.HEATMAP"  (click)="cambiarGraficaEstructura('HEATMAP', 2)">
                  <mat-icon [ngStyle]="{'color':'gray'}">view_quilt</mat-icon>
                  <span>{{'graf.calor'|translate}}</span>
                </button>
                <button mat-menu-item  [ngClass]="{'w3-disabled': estructuraP1.tipo === typeGrap.PIE}"
                [disabled]="estructuraP1.tipo === typeGrap.PIE"  (click)="cambiarGraficaEstructura('PIE', 2)">
                  <mat-icon [ngStyle]="{'color':'gray'}">pie_chart</mat-icon>
                  <span>{{'graf.pie'|translate}}</span>
                </button>
              </mat-menu>
            </div>
          </div>
          <div class="grafEstruc">
            @if (estructuraP1.data.length > 0) {
              <app-graficador
                [data]="estructuraP1.data"
                [labels]="estructuraP1.etiquetas"
                [type]="estructuraP1.tipo"
                [colors]="coloresGraf2"
                [axisY]="['']"
                [axisX]="''"
                [zona]="3"
                [legend]="estructuraP1.tipo === typeGrap.PIE ? {enabled: true, position: 'right'} : {enabled: false, position: 'bottom'}"
                [etiquetas]="estructuraP1.showLabels"
                [altoEtiquetasX] = "estructuraP1.tipo === typeGrap.BARHORIZONTAL ? 200 : 100"
                [animations]="false"
                [distributed]="estructuraP1.tipo !== typeGrap.PIE"
                [formatEtiquetas]="false"
                [divisionesEjeX]="2"
                [agruparCategoriasExcedentes]="true"
                [maxCategoriasVisibles]="5"
                [etiquetaOtros]="'segPresupuestal.estadoFinanciero.otros' | translate"
                [ordenCategorias]="'descendente'"
                [info]="'segPresupuestal.estadoFinanciero.info' | translate"
                (eventClick)="filtroEstruc1($event)">
              </app-graficador>
            }@else {<app-skeleton-grafica />}
          </div>
        </div>
        <div class="w3-row w3-half w3-white conteEstructura" style="margin-top: 1%">
          <div class="w3-row w3-titulo-contenidomenuSC">
            <div class="headers w3-setenta textoOverFlow"  style="width: 65%;"
              matTooltip="{{estructuraR2.titulo}} &bull; {{'segPresupuestal.estadoFinanciero.titTab4' | translate}} {{periodoSeleccionado.nombre}}">
              <span class="w3-margin-left-contenido">{{estructuraR2.titulo}} | {{'segPresupuestal.estadoFinanciero.titTab4' | translate}} </span>
              <span class="w3-margin-left-contenido">&bull;</span>
              <span class="w3-margin-left-filter w3-subtitulo">{{periodoSeleccionado?.nombre}}</span>
            </div>
            <div class="w3-rest w3-right">
              @if (estructuraR2.filtroActivado) {
                <div class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                (click)="borrarFiltroEstructura(2)" style="transform: scale(0.9);" matTooltip="{{'financiero.catalogoCuentas.tooltipIcono7'|translate}}">
                  <img src="assets/img/eraser.png">
                </div>
              }
              <mat-icon fontSet="material-icons-outlined" class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
              (click)="estructuraR2.showLabels = !estructuraR2.showLabels" matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
                {{ estructuraR2.showLabels ? 'label_off' : 'label' }}
              </mat-icon> 
              <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
              (click)="ampliarGraf(4)" matTooltip="{{'financiero.catalogoCuentas.tooltipIcono2'|translate}}">
                zoom_out_map
              </mat-icon>
              <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
              [matMenuTriggerFor]="menuGraf3">
                more_vert
              </mat-icon>
              <mat-menu #menuGraf3="matMenu">
                <button class="mat-menu-item w3-caja-menu" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="graficas3">
                  <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                  <span>{{'financiero.catalogoCuentas.tooltipIcono3'|translate}}</span>
                </button>  
                <button class="mat-menu-item w3-caja-menu" mat-menu-item class="w3-caja-menu" (click)="exportarGrafica(4)">
                  <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                  <span>{{'menu.Exportar'|translate}}</span>
                </button>
              </mat-menu>
              <mat-menu #graficas3="matMenu">
                <button mat-menu-item  [ngClass]="{'w3-disabled': estructuraR2.tipo === typeGrap.BAR}" 
                [disabled]="estructuraR2.tipo === typeGrap.BAR"  (click)="cambiarGraficaEstructura('BAR', 3)">
                  <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                  <span>{{'graf.vertical'|translate}}</span>
                </button>
                <button mat-menu-item [ngClass]="{'w3-disabled': estructuraR2.tipo === typeGrap.LINE}" 
                [disabled]="estructuraR2.tipo === typeGrap.LINE" (click)="cambiarGraficaEstructura('LINE', 3)">
                  <mat-icon [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
                  <span>{{'graf.lineal'|translate}}</span>
                </button>
                <button mat-menu-item  [ngClass]="{'w3-disabled': estructuraR2.tipo === typeGrap.BARHORIZONTAL}" 
                [disabled]="estructuraR2.tipo === typeGrap.BARHORIZONTAL"  (click)="cambiarGraficaEstructura('BARHORIZONTAL', 3)">
                  <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                  <span>{{'graf.horizontal'|translate}}</span>
                </button>
                <button mat-menu-item  [ngClass]="{'w3-disabled': estructuraR2.tipo === typeGrap.HEATMAP}"
                [disabled]="estructuraR2.tipo === typeGrap.HEATMAP"  (click)="cambiarGraficaEstructura('HEATMAP', 3)">
                  <mat-icon [ngStyle]="{'color':'gray'}">view_quilt</mat-icon>
                  <span>{{'graf.calor'|translate}}</span>
                </button>
                <button mat-menu-item  [ngClass]="{'w3-disabled': estructuraR2.tipo === typeGrap.PIE}"
                [disabled]="estructuraR2.tipo === typeGrap.PIE"  (click)="cambiarGraficaEstructura('PIE', 3)">
                  <mat-icon [ngStyle]="{'color':'gray'}">pie_chart</mat-icon>
                  <span>{{'graf.pie'|translate}}</span>
                </button>
              </mat-menu>
            </div>
          </div>
          <div class="grafEstruc">
            @if (estructuraR2.data.length > 0) {
              <app-graficador
                [data]="estructuraR2.data"
                [labels]="estructuraR2.etiquetas"
                [type]="estructuraR2.tipo"
                [colors]="coloresGraf2"
                [axisY]="['']"
                [axisX]="''"
                [zona]="4"
                [legend]="estructuraR2.tipo === typeGrap.PIE ? {enabled: true, position: 'right'} : {enabled: false, position: 'bottom'}"
                [etiquetas]="estructuraR2.showLabels"
                [animations]="false"
                [altoEtiquetasX] = "estructuraR2.tipo === typeGrap.BARHORIZONTAL ? 200 : 100"
                [distributed]="estructuraR2.tipo !== typeGrap.PIE"
                [formatEtiquetas]="false"
                [divisionesEjeX]="2"
                [agruparCategoriasExcedentes]="true"
                [maxCategoriasVisibles]="5"
                [etiquetaOtros]="'segPresupuestal.estadoFinanciero.otros' | translate"
                [ordenCategorias]="'descendente'"
                [info]="'segPresupuestal.estadoFinanciero.info' | translate"
                (eventClick)="filtroEstruc2($event)">
              </app-graficador>
            }@else {<app-skeleton-grafica />}
          </div>
        </div>
        <div class="w3-row w3-half w3-white conteEstructura" style="margin-top: 1%">
          <div class="w3-row w3-titulo-contenidomenuSC">
            <div class="headers w3-setenta textoOverFlow" style="width: 65%;"
            matTooltip="{{estructuraP2.titulo}} &bull; {{'segPresupuestal.estadoFinanciero.titTab4' | translate}} {{periodoSeleccionado.nombre}}">
              <span class="w3-margin-left-contenido">{{estructuraP2.titulo}} | {{'segPresupuestal.estadoFinanciero.titTab3' | translate}}</span>
              <span class="w3-margin-left-contenido">&bull;</span>
              <span class="w3-margin-left-filter w3-subtitulo"> {{periodoSeleccionado?.nombre}}</span>
            </div>
            <div class="w3-rest w3-right">
              @if (estructuraP2.filtroActivado) {
                <div class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                (click)="borrarFiltroEstructura(2)" style="transform: scale(0.9);" matTooltip="{{'financiero.catalogoCuentas.tooltipIcono7'|translate}}">
                  <img src="assets/img/eraser.png">
                </div>
              }
              <mat-icon fontSet="material-icons-outlined" class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
              (click)="estructuraP2.showLabels = !estructuraP2.showLabels" matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
                {{ estructuraP2.showLabels ? 'label_off' : 'label' }}
              </mat-icon> 
              <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
              (click)="ampliarGraf(5)" matTooltip="{{'financiero.catalogoCuentas.tooltipIcono2'|translate}}">
                zoom_out_map
              </mat-icon>
              <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
              [matMenuTriggerFor]="menuGraf4">
                more_vert
              </mat-icon>
              <mat-menu #menuGraf4="matMenu">
                <button class="mat-menu-item w3-caja-menu" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="graficas4">
                  <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                  <span>{{'financiero.catalogoCuentas.tooltipIcono3'|translate}}</span>
                </button>
                <button class="mat-menu-item w3-caja-menu" mat-menu-item class="w3-caja-menu" (click)="exportarGrafica(5)">
                  <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                  <span>{{'menu.Exportar'|translate}}</span>
                </button>
              </mat-menu>
              <mat-menu #graficas4="matMenu">
                <button mat-menu-item  [ngClass]="{'w3-disabled': estructuraP2.tipo === typeGrap.BAR}" 
                [disabled]="estructuraP2.tipo === typeGrap.BAR"  (click)="cambiarGraficaEstructura('BAR', 4)">
                  <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                  <span>{{'graf.vertical'|translate}}</span>
                </button>
                <button mat-menu-item [ngClass]="{'w3-disabled': estructuraP2.tipo === typeGrap.LINE}" 
                [disabled]="estructuraP2.tipo === typeGrap.LINE" (click)="cambiarGraficaEstructura('LINE', 4)">
                  <mat-icon [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
                  <span>{{'graf.lineal'|translate}}</span>
                </button>
                <button mat-menu-item  [ngClass]="{'w3-disabled': estructuraP2.tipo === typeGrap.BARHORIZONTAL}" 
                [disabled]="estructuraP2.tipo === typeGrap.BARHORIZONTAL"  (click)="cambiarGraficaEstructura('BARHORIZONTAL', 4)">
                  <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                  <span>{{'graf.horizontal'|translate}}</span>
                </button>
                <button mat-menu-item  [ngClass]="{'w3-disabled': estructuraP2.tipo === typeGrap.HEATMAP}"
                [disabled]="estructuraP2.tipo === typeGrap.HEATMAP"  (click)="cambiarGraficaEstructura('HEATMAP', 4)">
                  <mat-icon [ngStyle]="{'color':'gray'}">view_quilt</mat-icon>
                  <span>{{'graf.calor'|translate}}</span>
                </button>
                <button mat-menu-item  [ngClass]="{'w3-disabled': estructuraP2.tipo === typeGrap.PIE}"
                [disabled]="estructuraP2.tipo === typeGrap.PIE"  (click)="cambiarGraficaEstructura('PIE', 4)">
                  <mat-icon [ngStyle]="{'color':'gray'}">pie_chart</mat-icon>
                  <span>{{'graf.pie'|translate}}</span>
                </button>
              </mat-menu>
            </div>
          </div>
          <div class="grafEstruc">
            @if (estructuraP2.data.length > 0) {
              <app-graficador
                [data]="estructuraP2.data"
                [labels]="estructuraP2.etiquetas"
                [type]="estructuraP2.tipo"
                [colors]="coloresGraf2"
                [axisY]="['']"
                [axisX]="''"
                [zona]="5"
                [legend]="estructuraP2.tipo === typeGrap.PIE ? {enabled: true, position: 'right'} : {enabled: false, position: 'bottom'}"
                [etiquetas]="estructuraP2.showLabels"
                [animations]="false"
                [altoEtiquetasX] = "estructuraP2.tipo === typeGrap.BARHORIZONTAL ? 200 : 100"
                [distributed]="estructuraP2.tipo !== typeGrap.PIE"
                [formatEtiquetas]="false"
                [divisionesEjeX]="2"
                [agruparCategoriasExcedentes]="true"
                [maxCategoriasVisibles]="5"
                [etiquetaOtros]="'segPresupuestal.estadoFinanciero.otros' | translate"
                [ordenCategorias]="'descendente'"
                [info]="'segPresupuestal.estadoFinanciero.info' | translate"
                (eventClick)="filtroEstruc2($event)">
              </app-graficador>
            }@else {<app-skeleton-grafica />}
          </div>
        </div>
        <div class="w3-row w3-half w3-white conteEstructura" style="margin-top: 1%">
          <div class="w3-row w3-titulo-contenidomenuSC">
            <div class="headers w3-setenta textoOverFlow" style="width: 65%;"
              matTooltip="{{estructuraR3.titulo}} &bull; {{'segPresupuestal.estadoFinanciero.titTab4' | translate}} {{periodoSeleccionado.nombre}}">
              <span class="w3-margin-left-contenido">{{estructuraR3.titulo}} | {{'segPresupuestal.estadoFinanciero.titTab4' | translate}}</span>
              <span class="w3-margin-left-contenido">&bull;</span>
              <span class="w3-margin-left-filter w3-subtitulo"> {{periodoSeleccionado?.nombre}}</span>
            </div>
            <div class="w3-rest w3-right">
              @if (estructuraR3.filtroActivado) {
                <div class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                (click)="borrarFiltroEstructura(3)" style="transform: scale(0.9);" matTooltip="{{'financiero.catalogoCuentas.tooltipIcono7'|translate}}">
                  <img src="assets/img/eraser.png">
                </div>
              }
              <mat-icon fontSet="material-icons-outlined" class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
              (click)="estructuraR3.showLabels = !estructuraR3.showLabels" matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
                {{ estructuraR3.showLabels ? 'label_off' : 'label' }}
              </mat-icon> 
              <mat-icon class="w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
              (click)="ampliarGraf(6)" matTooltip="{{'financiero.catalogoCuentas.tooltipIcono2'|translate}}">
                zoom_out_map
              </mat-icon>
              <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
              [matMenuTriggerFor]="menuGraf5">
                more_vert
              </mat-icon>
              <mat-menu #menuGraf5="matMenu">
                <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="graficas5">
                  <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                  <span>{{'financiero.catalogoCuentas.tooltipIcono3'|translate}}</span>
                </button>
                <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportarGrafica(6)">
                  <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                  <span>{{'menu.Exportar'|translate}}</span>
                </button>
              </mat-menu>
              <mat-menu #graficas5="matMenu">
                <button mat-menu-item  [ngClass]="{'w3-disabled': estructuraR3.tipo === typeGrap.BAR}" 
                [disabled]="estructuraR3.tipo === typeGrap.BAR"  (click)="cambiarGraficaEstructura('BAR', 5)">
                  <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                  <span>{{'graf.vertical'|translate}}</span>
                </button>
                <button mat-menu-item [ngClass]="{'w3-disabled': estructuraR3.tipo === typeGrap.LINE}" 
                [disabled]="estructuraR3.tipo === typeGrap.LINE" (click)="cambiarGraficaEstructura('LINE', 5)">
                  <mat-icon [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
                  <span>{{'graf.lineal'|translate}}</span>
                </button>
                <button mat-menu-item  [ngClass]="{'w3-disabled': estructuraR3.tipo === typeGrap.BARHORIZONTAL}" 
                [disabled]="estructuraR3.tipo === typeGrap.BARHORIZONTAL"  (click)="cambiarGraficaEstructura('BARHORIZONTAL', 5)">
                  <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                  <span>{{'graf.horizontal'|translate}}</span>
                </button>
                <button mat-menu-item  [ngClass]="{'w3-disabled': estructuraR3.tipo === typeGrap.HEATMAP}"
                [disabled]="estructuraR3.tipo === typeGrap.HEATMAP"  (click)="cambiarGraficaEstructura('HEATMAP', 5)">
                  <mat-icon [ngStyle]="{'color':'gray'}">view_quilt</mat-icon>
                  <span>{{'graf.calor'|translate}}</span>
                </button>
                <button mat-menu-item  [ngClass]="{'w3-disabled': estructuraR3.tipo === typeGrap.PIE}"
                [disabled]="estructuraR3.tipo === typeGrap.PIE"  (click)="cambiarGraficaEstructura('PIE', 5)">
                  <mat-icon [ngStyle]="{'color':'gray'}">pie_chart</mat-icon>
                  <span>{{'graf.pie'|translate}}</span>
                </button>
              </mat-menu>
            </div>
          </div>
          <div class="grafEstruc">
            @if (estructuraR3.data.length > 0) {
              <app-graficador
                [data]="estructuraR3.data"
                [labels]="estructuraR3.etiquetas"
                [type]="estructuraR3.tipo"
                [colors]="coloresGraf2"
                [axisY]="['']"
                [axisX]="''"
                [zona]="6"
                [legend]="estructuraR3.tipo === typeGrap.PIE ? {enabled: true, position: 'right'} : {enabled: false, position: 'bottom'}"
                [etiquetas]="estructuraR3.showLabels"
                [animations]="false"
                [altoEtiquetasX] = "estructuraR3.tipo === typeGrap.BARHORIZONTAL ? 200 : 100"
                [distributed]="estructuraR3.tipo !== typeGrap.PIE"
                [formatEtiquetas]="false"
                [divisionesEjeX]="2"
                [agruparCategoriasExcedentes]="true"
                [maxCategoriasVisibles]="5"
                [etiquetaOtros]="'segPresupuestal.estadoFinanciero.otros' | translate"
                [ordenCategorias]="'descendente'"
                [info]="'segPresupuestal.estadoFinanciero.info' | translate"
                (eventClick)="filtroEstruc3($event)">
              </app-graficador>
            }@else {<app-skeleton-grafica />}
          </div>
        </div>
        <div class="w3-row w3-half w3-white conteEstructura" style="margin-top: 1%">
          <div class="w3-row w3-titulo-contenidomenuSC"> 
            <div class="headers w3-setenta textoOverFlow" style="width: 65%;"
            matTooltip="{{estructuraP3.titulo}} &bull; {{'segPresupuestal.estadoFinanciero.titTab3' | translate}} {{periodoSeleccionado.nombre}}">
              <span class="w3-margin-left-contenido">{{estructuraP3.titulo}} | {{'segPresupuestal.estadoFinanciero.titTab3' | translate}}</span>
              <span class="w3-margin-left-contenido">&bull;</span>
              <span class="w3-margin-left-filter w3-subtitulo"> {{periodoSeleccionado?.nombre}}</span>
            </div>
            <div class="w3-rest w3-right">
              @if (estructuraP3.filtroActivado) {
                <div class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                (click)="borrarFiltroEstructura(3)" style="transform: scale(0.9);" matTooltip="{{'financiero.catalogoCuentas.tooltipIcono7'|translate}}">
                  <img src="assets/img/eraser.png">
                </div>
              }
              <mat-icon fontSet="material-icons-outlined" class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
              (click)="estructuraP3.showLabels = !estructuraP3.showLabels" matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
                {{ estructuraP3.showLabels ? 'label_off' : 'label' }}
              </mat-icon> 
              <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
              (click)="ampliarGraf(7)" matTooltip="{{'financiero.catalogoCuentas.tooltipIcono2'|translate}}">
                zoom_out_map
              </mat-icon>
              <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
              [matMenuTriggerFor]="menuGraf6">
                more_vert
              </mat-icon>
              <mat-menu #menuGraf6="matMenu">
                <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="graficas6">
                  <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                  <span>{{'financiero.catalogoCuentas.tooltipIcono3'|translate}}</span>
                </button>  
                <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportarGrafica(7)">
                  <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                  <span>{{'menu.Exportar'|translate}}</span>
                </button>
              </mat-menu>
              <mat-menu #graficas6="matMenu">
                <button mat-menu-item  [ngClass]="{'w3-disabled': estructuraP3.tipo === typeGrap.BAR}" 
                [disabled]="estructuraP3.tipo === typeGrap.BAR"  (click)="cambiarGraficaEstructura('BAR', 6)">
                  <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                  <span>{{'graf.vertical'|translate}}</span>
                </button>
                <button mat-menu-item [ngClass]="{'w3-disabled': estructuraP3.tipo === typeGrap.LINE}" 
                [disabled]="estructuraP3.tipo === typeGrap.LINE" (click)="cambiarGraficaEstructura('LINE', 6)">
                  <mat-icon [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
                  <span>{{'graf.lineal'|translate}}</span>
                </button>
                <button mat-menu-item  [ngClass]="{'w3-disabled': estructuraP3.tipo === typeGrap.BARHORIZONTAL}" 
                [disabled]="estructuraP3.tipo === typeGrap.BARHORIZONTAL"  (click)="cambiarGraficaEstructura('BARHORIZONTAL', 6)">
                  <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                  <span>{{'graf.horizontal'|translate}}</span>
                </button>
                <button mat-menu-item  [ngClass]="{'w3-disabled': estructuraP3.tipo === typeGrap.HEATMAP}"
                [disabled]="estructuraP3.tipo === typeGrap.HEATMAP"  (click)="cambiarGraficaEstructura('HEATMAP', 6)">
                  <mat-icon [ngStyle]="{'color':'gray'}">view_quilt</mat-icon>
                  <span>{{'graf.calor'|translate}}</span>
                </button>
                <button mat-menu-item  [ngClass]="{'w3-disabled': estructuraP3.tipo === typeGrap.PIE}"
                [disabled]="estructuraP3.tipo === typeGrap.PIE"  (click)="cambiarGraficaEstructura('PIE', 6)">
                  <mat-icon [ngStyle]="{'color':'gray'}">pie_chart</mat-icon>
                  <span>{{'graf.pie'|translate}}</span>
                </button>
              </mat-menu>
            </div>
          </div>
          <div class="grafEstruc">
            @if (estructuraP3.data.length > 0) {
              <app-graficador
                [data]="estructuraP3.data"
                [labels]="estructuraP3.etiquetas"
                [type]="estructuraP3.tipo"
                [colors]="coloresGraf2"
                [axisY]="['']"
                [axisX]="''"
                [zona]="7"
                [legend]="estructuraP3.tipo === typeGrap.PIE ? {enabled: true, position: 'right'} : {enabled: false, position: 'bottom'}"
                [etiquetas]="estructuraP3.showLabels"
                [animations]="false"
                [altoEtiquetasX] = "estructuraP3.tipo === typeGrap.BARHORIZONTAL ? 200 : 100"
                [distributed]="estructuraP3.tipo !== typeGrap.PIE"
                [formatEtiquetas]="false"
                [divisionesEjeX]="2"
                [agruparCategoriasExcedentes]="true"
                [maxCategoriasVisibles]="5"
                [etiquetaOtros]="'segPresupuestal.estadoFinanciero.otros' | translate"
                [ordenCategorias]="'descendente'"
                [info]="'segPresupuestal.estadoFinanciero.info' | translate"
                (eventClick)="filtroEstruc3($event)">
              </app-graficador>
            }@else {<app-skeleton-grafica />}
          </div>
        </div>
      </div>        
    }
  </div>
</app-esqueleto-tableros>

<!--Modal ampliar grafica-->
<app-modal [isOpen]="modalOpen" (close)="modalOpen = !modalOpen">
  <div modal-header>
    <div class="w3-row w3-white" style="width: 70vw;">
      <!--Titulo grafica modal-->
      <div class="w3-row w3-half w3-white">
        <div class="w3-row w3-header-cuadrante padreizquierda" style="height: 6vh; margin-top: 10px; margin-left: 20px">
          <div class="w3-noventa2 w3-titulo-contenidomenu  hijoizquierdaTitle">
            <span class="w3-margin-left-contenido">{{tituloModal}} </span>
            <span class="w3-punto-subtitulo w3-margin-left-filter">&bull;</span>
            <span class=" w3-margin-left-filter w3-subtitulo">{{ subtituloModal }}</span>
          </div>
        </div>
      </div>
      <!--cerrar modal-->
      <div class="w3-rest w3-right w3-white" style="height: 6vh;">
        <div class="w3-row" style="height: 3vh; transform: translate(0, 40%);">
          @if (estructuraR1.filtroActivado && graficaAmp === 2) {
            <div class="w3-margin-right-contenido w3-button w3-dropdown-click" style="transform: scale(0.9);" [ngStyle]="{'color':'gray'}" 
            (click)="borrarFiltroEstructura(1)"
            matTooltip="{{'financiero.catalogoCuentas.tooltipIcono7'|translate}}">
              <img src="assets/img/eraser.png">
            </div>
          }
          @if (estructuraP1.filtroActivado && graficaAmp === 3) {
            <div class="w3-margin-right-contenido w3-button w3-dropdown-click" style="transform: scale(0.9);" [ngStyle]="{'color':'gray'}" 
            (click)="borrarFiltroEstructura(1)"
            matTooltip="{{'financiero.catalogoCuentas.tooltipIcono7'|translate}}">
              <img src="assets/img/eraser.png">
            </div>
          }
          @if (estructuraR2.filtroActivado && graficaAmp === 4) {
            <div class="w3-margin-right-contenido w3-button w3-dropdown-click" style="transform: scale(0.9);" [ngStyle]="{'color':'gray'}" 
            (click)="borrarFiltroEstructura(2)"
            matTooltip="{{'financiero.catalogoCuentas.tooltipIcono7'|translate}}">
              <img src="assets/img/eraser.png">
            </div>
          }
          @if (estructuraP2.filtroActivado && graficaAmp === 5) {
            <div class="w3-margin-right-contenido w3-button w3-dropdown-click" style="transform: scale(0.9);" [ngStyle]="{'color':'gray'}" 
            (click)="borrarFiltroEstructura(2)"
            matTooltip="{{'financiero.catalogoCuentas.tooltipIcono7'|translate}}">
              <img src="assets/img/eraser.png">
            </div>
          }
          @if (estructuraR3.filtroActivado && graficaAmp === 6) {
            <div class="w3-margin-right-contenido w3-button w3-dropdown-click" style="transform: scale(0.9);" [ngStyle]="{'color':'gray'}" 
            (click)="borrarFiltroEstructura(3)"
            matTooltip="{{'financiero.catalogoCuentas.tooltipIcono7'|translate}}">
              <img src="assets/img/eraser.png">
            </div>
          }
          @if (estructuraP3.filtroActivado && graficaAmp === 7) {
            <div class="w3-margin-right-contenido w3-button w3-dropdown-click" style="transform: scale(0.9);" [ngStyle]="{'color':'gray'}" 
            (click)="borrarFiltroEstructura(3)"
            matTooltip="{{'financiero.catalogoCuentas.tooltipIcono7'|translate}}">
              <img src="assets/img/eraser.png">
            </div>
          }
          @if (graficaAmp === 1) {
            <mat-icon fontSet="material-icons-outlined" class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            (click)="etiquetas = !etiquetas" matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
              {{ etiquetas ? 'label_off' : 'label' }}
            </mat-icon>
          }
          @if (graficaAmp === 2) {
            <mat-icon fontSet="material-icons-outlined" class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            (click)="estructuraR1.showLabels= !estructuraR1.showLabels" matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
              {{ estructuraR1.showLabels ? 'label_off' : 'label' }}
            </mat-icon>
          }
          @if (graficaAmp === 3) {
            <mat-icon fontSet="material-icons-outlined" class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            (click)="estructuraP1.showLabels = !estructuraP1.showLabels" matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
              {{ estructuraP1.showLabels ? 'label_off' : 'label' }}
            </mat-icon>
          }
          @if (graficaAmp === 4) {
            <mat-icon fontSet="material-icons-outlined" class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            (click)="estructuraR2.showLabels = !estructuraR2.showLabels" matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
              {{ estructuraR2.showLabels ? 'label_off' : 'label' }}
            </mat-icon>
          }
          @if (graficaAmp === 5) {
            <mat-icon fontSet="material-icons-outlined" class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            (click)="estructuraP2.showLabels= !estructuraP2.showLabels" matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
              {{ estructuraP2.showLabels ? 'label_off' : 'label' }}
            </mat-icon>
          }
          @if (graficaAmp === 6) {
            <mat-icon fontSet="material-icons-outlined" class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            (click)="estructuraR3.showLabels = !estructuraR3.showLabels" matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
              {{ estructuraR3.showLabels ? 'label_off' : 'label' }}
            </mat-icon>
          }
          @if (graficaAmp === 7) {
            <mat-icon fontSet="material-icons-outlined" class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            (click)="estructuraP3.showLabels = !estructuraP3.showLabels" matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
              {{ estructuraP3.showLabels ? 'label_off' : 'label' }}
            </mat-icon>
          }
          <!-- Icono exportar -->
          <mat-icon class="w3-margin-right-contenido w3-button" [ngStyle]="{'color':'gray'}"
            (click)="exportarGrafica(graficaAmp)" matTooltip="{{'menu.Exportar'|translate}}">
            image
          </mat-icon>
        </div>
      </div>
    </div>
  </div>
  <div modal-body style="height: 60vh;">
    <!--area grafica-->
    <div style="width: 100%;" >
      <div class="w3-row" style="height: 58vh;">
        @if (modalOpen) {
          @if(graficaAmp === 1){
            <app-graficador 
              [data]="datoGrafico" 
              [labels]="etiquetasGrafico" 
              [type]="tipoGraficaActual"
              [colors]="coloresGrafico" 
              [axisY]="['% Cumplimiento', 'Millones']" 
              [axisX]="''" 
              [zona]="8" 
              [etiquetas]="etiquetas"
              [changeLabel]="changeLabel"
              [formatEtiquetas]="true"
              [legend]="{enabled: true, position: 'bottom'}"
              [animations]="true"
              [setTwoLast]="ejes"
              [stroke]="false">
            </app-graficador>
          }
          @if(graficaAmp === 2){
            <app-graficador 
              [data]="estructuraR1.data"
              [labels]="estructuraR1.etiquetas"
              [type]="estructuraR1.tipo"
              [colors]="coloresGraf2"
              [axisY]="['']"
              [axisX]="''"
              [zona]="9"
              [legend]="estructuraR1.tipo === typeGrap.PIE ? {enabled: true, position: 'right'} : {enabled: false, position: 'bottom'}"
              [etiquetas]="estructuraR1.showLabels"
              [animations]="false"
              [ordenCategorias]="'descendente'"
              [info]="'segPresupuestal.estadoFinanciero.info' | translate"
              (eventClick)="filtroEstruc1($event)">
            </app-graficador>
          }
          @if(graficaAmp === 3){
            <app-graficador 
              [data]="estructuraP1.data"
              [labels]="estructuraP1.etiquetas"
              [type]="estructuraP1.tipo"
              [colors]="coloresGraf2"
              [axisY]="['']"
              [axisX]="''"
              [zona]="10"
              [legend]="estructuraP1.tipo === typeGrap.PIE ? {enabled: true, position: 'right'} : {enabled: false, position: 'bottom'}"
              [etiquetas]="estructuraP1.showLabels"
              [animations]="false"
              [ordenCategorias]="'descendente'"
              [info]="'segPresupuestal.estadoFinanciero.info' | translate"
              (eventClick)="filtroEstruc1($event)">
            </app-graficador>
          }
          @if(graficaAmp === 4){
            <app-graficador 
              [data]="estructuraR2.data"
              [labels]="estructuraR2.etiquetas"
              [type]="estructuraR2.tipo"
              [colors]="coloresGraf2"
              [axisY]="['']"
              [axisX]="''"
              [zona]="11"
              [legend]="estructuraR2.tipo === typeGrap.PIE ? {enabled: true, position: 'right'} : {enabled: false, position: 'bottom'}"
              [etiquetas]="estructuraR2.showLabels"
              [animations]="false"
              [ordenCategorias]="'descendente'"
              [info]="'segPresupuestal.estadoFinanciero.info' | translate"
              (eventClick)="filtroEstruc2($event)">
            </app-graficador>
          }
          @if(graficaAmp === 5){
            <app-graficador 
              [data]="estructuraP2.data"
              [labels]="estructuraP2.etiquetas"
              [type]="estructuraP2.tipo"
              [colors]="coloresGraf2"
              [axisY]="['']"
              [axisX]="''"
              [zona]="12"
              [legend]="estructuraP2.tipo === typeGrap.PIE ? {enabled: true, position: 'right'} : {enabled: false, position: 'bottom'}"
              [etiquetas]="estructuraP2.showLabels"
              [animations]="false"
              [ordenCategorias]="'descendente'"
              [info]="'segPresupuestal.estadoFinanciero.info' | translate"
              (eventClick)="filtroEstruc2($event)">
            </app-graficador>
          }
          @if(graficaAmp === 6){
            <app-graficador 
              [data]="estructuraR3.data"
              [labels]="estructuraR3.etiquetas"
              [type]="estructuraR3.tipo"
              [colors]="coloresGraf2"
              [axisY]="['']"
              [axisX]="''"
              [zona]="11"
              [legend]="estructuraR3.tipo === typeGrap.PIE ? {enabled: true, position: 'right'} : {enabled: false, position: 'bottom'}"
              [etiquetas]="estructuraR3.showLabels"
              [animations]="false"
              [ordenCategorias]="'descendente'"
              [info]="'segPresupuestal.estadoFinanciero.info' | translate"
              (eventClick)="filtroEstruc3($event)">
            </app-graficador>
          }
          @if(graficaAmp === 7){
            <app-graficador 
              [data]="estructuraP3.data"
              [labels]="estructuraP3.etiquetas"
              [type]="estructuraP3.tipo"
              [colors]="coloresGraf2"
              [axisY]="['']"
              [axisX]="''"
              [zona]="12"
              [legend]="estructuraP3.tipo === typeGrap.PIE ? {enabled: true, position: 'right'} : {enabled: false, position: 'bottom'}"
              [etiquetas]="estructuraP3.showLabels"
              [animations]="false"
              [ordenCategorias]="'descendente'"
              [info]="'segPresupuestal.estadoFinanciero.info' | translate"
              (eventClick)="filtroEstruc3($event)">
            </app-graficador>
          }
        }
      </div>
    </div>
  </div>
</app-modal>
